// frontend/src/prod-url-patch.js
(function () {
  const FROM = 'http://127.0.0.1:5000';
  const TO =
    (typeof process !== 'undefined' &&
      process.env &&
      process.env.VUE_APP_API_URL) ||
    FROM;

  if (!TO || TO === FROM) return;

  // --- Patch fetch ---
  const origFetch = window.fetch ? window.fetch.bind(window) : null;
  if (origFetch) {
    window.fetch = function (input, init) {
      if (typeof input === 'string' && input.startsWith(FROM)) {
        input = TO + input.substring(FROM.length);
      } else if (input && typeof input === 'object' && input.url && input.url.startsWith(FROM)) {
        input = new Request(TO + input.url.substring(FROM.length), input);
      }
      return origFetch(input, init);
    };
  }

  // --- Patch XHR (covers axios in browser) ---
  if (window.XMLHttpRequest) {
    const origOpen = window.XMLHttpRequest.prototype.open;
    window.XMLHttpRequest.prototype.open = function (method, url, async, user, password) {
      if (typeof url === 'string' && url.startsWith(FROM)) {
        url = TO + url.substring(FROM.length);
      }
      return origOpen.call(this, method, url, async, user, password);
    };
  }

  // --- Patch WebSocket (if any ws://127.0.0.1:5000 usage) ---
  const WS_FROM = 'ws://127.0.0.1:5000';
  const WSS_TO = TO.replace(/^http/, 'ws');
  if (window.WebSocket) {
    const OrigWS = window.WebSocket;
    window.WebSocket = function (url, protocols) {
      if (typeof url === 'string' && url.startsWith(WS_FROM)) {
        url = WSS_TO + url.substring(WS_FROM.length);
      }
      return new OrigWS(url, protocols);
    };
    window.WebSocket.prototype = OrigWS.prototype;
  }
})();
